import React, { useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../../routes/route";
import useBetSdk from "../../../hooks/useBetSdk";
import { getCommonParams } from "../../../config/betConfig";
import AuthContext from "../../../Auth/AuthContext";

const LiveEventsPage = () => {
  const isReady = useBetSdk();
  const initializedRef = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const isFullPage = location.pathname === routes.pages.sportsbook.liveEvents;

  const handleClose = () => navigate(-1);

  useEffect(() => {
    if (!isReady || !window.BetSdk || initializedRef.current) return;

    initializedRef.current = true;
    let isMounted = true;

    const initWidget = async () => {
      let customStylesUri = "/assets/css/sportsbook.css";

      // Load custom CSS
      try {
        const res = await fetch(customStylesUri);
        if (res.ok) {
          const css = await res.text();
          const base64 = btoa(unescape(encodeURIComponent(css)));
          customStylesUri = `data:text/css;base64,${base64}`;
        }
      } catch (error) {
        console.error("Failed to load custom sportsbook CSS:", error);
      }

      if (!isMounted) return;

      const params = getCommonParams(customStylesUri);
      const container = document.getElementById("live-events-widget-container");
      if (!container) return;

      // Clear old widget
      container.innerHTML = "";

      // Initialize SDK widget
      if (window.BetSdk?.initLiveEventsWidget) {
        window.BetSdk.initLiveEventsWidget({
          ...params,
          containerId: "live-events-widget-container",
          height: "372px",
          // SDK callbacks (if supported)
          onPlaceBetClick: () => navigate("/turbo-sports"),
          onSeeAllClick: () => navigate("/turbo-sports"),
        });
      }
    };

    initWidget();

    return () => {
      isMounted = false;
      initializedRef.current = false;
    };
  }, [isReady, navigate]);

  const renderContent = () => (
    <div style={{ position: "relative" }}>
      <div className="top-matches-title my-3">
        <div className="d-flex align-items-center">
          <span className="dot" />
          <h5 className="m-0 ms-2 d-flex align-items-center">Live Events</h5>
        </div>
      </div>

      <div id="live-events-widget-container" style={{ position: "relative" }}></div>

      {/* 🔥 Full-size Overlay for logged-out users */}
      {!user && (
        <div
          onClick={() => navigate("/login")}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9999,
            cursor: "pointer",
            backgroundColor: "transparent",
          }}
        ></div>
      )}

      {/* 🔥 Overlay div for "See All" button (only when logged in) */}
      {/* {user && (
        <div
          onClick={() => navigate("/turbo-sports")}
          style={{
            position: "absolute",
            top: "72px",
            right: "30px",
            width: "100px",
            height: "40px",
            zIndex: 9999,
            cursor: "pointer",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        ></div>
      )} */}
    </div>
  );

  if (isFullPage) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#000",
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <nav
          className="navbar py-2 navbar-dark bg-black sticky-top shadow-sm d-flex align-items-center justify-content-between position-relative border-bottom border-secondary"
          style={{ height: "60px" }}
        >
          <div className="container-fluid d-flex align-items-center justify-content-between position-relative px-3">
            <button
              className="go_back_btn bg-grey border-0 rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "35px", height: "35px" }}
              onClick={handleClose}
            >
              <i className="ri-arrow-left-s-line text-white fs-20" />
            </button>
            <h5 className="position-absolute start-50 translate-middle-x m-0 text-white fs-18 fw-bold">
              Live Events
            </h5>
            <div style={{ width: "35px" }} />
          </div>
        </nav>
        <div
          style={{
            flex: 1,
            width: "100%",
            backgroundColor: "#000",
            overflowY: "auto",
            padding: "0 10px",
          }}
        >
          {renderContent()}
        </div>
      </div>
    );
  }

  return renderContent();
};

export default LiveEventsPage;